"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetcherAmplify = void 0;
const aws_amplify_1 = require("aws-amplify");
const CurrentCustomer_1 = require("../CurrentCustomer");
class FetcherAmplify {
    scope = 'BlumAPI';
    fetcher = aws_amplify_1.API;
    get(endpoint, data) {
        return this.fetcher.get(this.scope, endpoint, {
            ...data,
            queryStringParameters: {
                ...data?.queryStringParameters,
                ...(CurrentCustomer_1.currentCustomer.getId() && {
                    customerId: CurrentCustomer_1.currentCustomer.getId(),
                }),
            },
        });
    }
    put(endpoint, data) {
        return this.fetcher.put(this.scope, endpoint, {
            ...data,
            queryStringParameters: {
                ...data?.queryStringParameters,
                ...(CurrentCustomer_1.currentCustomer.getId() && {
                    customerId: CurrentCustomer_1.currentCustomer.getId(),
                }),
            },
        });
    }
    post(endpoint, data) {
        return this.fetcher.post(this.scope, endpoint, {
            ...data,
            queryStringParameters: {
                ...data?.queryStringParameters,
                ...(CurrentCustomer_1.currentCustomer.getId() && {
                    customerId: CurrentCustomer_1.currentCustomer.getId(),
                }),
            },
        });
    }
    delete(endpoint, data) {
        return this.fetcher.del(this.scope, endpoint, {
            ...data,
            queryStringParameters: {
                ...data?.queryStringParameters,
                ...(CurrentCustomer_1.currentCustomer.getId() && {
                    customerId: CurrentCustomer_1.currentCustomer.getId(),
                }),
            },
        });
    }
}
exports.FetcherAmplify = FetcherAmplify;
//# sourceMappingURL=FetcherAmplify.js.map